import { takeEvery, call, put, all } from "redux-saga/effects";
import { actions, actionTypes } from "../actions/index";
import {
  fetchCountriesAPI,
  fetchUserInfoApi,
} from "../../api/endpoint";
import { actions as commonActions } from "../../store/actions";

function* getCountriesSaga(action) {
  try {
    const _api = yield call(fetchCountriesAPI, action.payload);
    yield put(actions.setCountries(_api.data.results));
    // yield put(commonActions.setLoading(false));
  } catch (error) {
    // yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getUserInfoSaga(action) {
  try {
    const _api = yield call(fetchUserInfoApi, action.payload);
    if (_api.data.results?.length === 0) {
      yield put(commonActions.setuserAvailability(false));
    }
    yield put(actions.setUserInfo(..._api.data.results));
    yield put(actions.setLoader(false));
    yield put(commonActions.setCountryAvailability(true));
  } catch (error) {
    // yield put(commonActions.setLoading(false));
    console.log(error);
  }
}


export function* watchCommonSaga() {
  yield all([
    takeEvery(actionTypes.GET_COUNTRIES, getCountriesSaga),
    takeEvery(actionTypes.GET_USER_INFO, getUserInfoSaga),
  ]);
}
